import React from 'react';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import './index.scss'

export default class CustomButton extends React.Component {

    handlePressedButton = (e) => {
        if(e.key === 'Enter') {
            this.props.onClick();
        }
    }
    
    render() {
        return (
                <Button
                    disabled={this.props.progressBar || this.props.disabled}
                    className={this.props.mystyle + " "+(this.props.progressBar ? "disabled" : "")+(this.props.justText ? " justText" : "")}
                    variant="contained"
                    onClick={this.props.onClick}
                    href={this.props.href}
                    type={this.props.submit ? "submit":"button"}
                    onKeyPress={this.props.pressButton ? this.handlePressedButton : void(0)}
                    classes={{
                        disabled: "disabled"
                    }}
                >
                    {this.props.children}
                    
                    {this.props.progressBar ?
                    <div>
                        {!this.props.progressBar ? <span>{this.props.title}</span>  : null}
                        <CircularProgress size={18} className={'progressbar'} />
                    </div>
                    :
                    <span className={this.props.justText ? "" :'button-title'}>{this.props.title}</span>
                    }
                </Button>
                
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/CustomButton/index.js